import { render } from "./ConfigsView.vue?vue&type=template&id=7dfc0e16&scoped=true"
import script from "./ConfigsView.vue?vue&type=script&lang=js"
export * from "./ConfigsView.vue?vue&type=script&lang=js"

import "./ConfigsView.vue?vue&type=style&index=0&id=7dfc0e16&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfc0e16"]])

export default __exports__